const baseRoute = 'chemical-trading/:moduleBridgeHex/';
export const routes = {
  // user_module_chemicalTrading_base: {
  //   path: baseRoute,
  //   parameters: {
  //     moduleBridgeHex: undefined,
  //   },
  // },
  user_module_chemicalTrading_home: {
    path: `${baseRoute}home/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_chemicalTrading_product_list: {
    path: `${baseRoute}product/list`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_chemicalTrading_product_new: {
    path: `${baseRoute}product/new/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_chemicalTrading_product_edit: {
    path: `${baseRoute}product/edit/:id/`,
    parameters: {
      moduleBridgeHex: undefined,
      id: undefined,
    },
  },
  user_module_chemicalTrading_product_home: {
    path: `${baseRoute}product/home/:id/`,
    parameters: {
      moduleBridgeHex: undefined,
      id: undefined,
    },
  },
};
